import { stringFormat } from './string-format'

const NATIONAL_NUMBER_MAX_LENGTH = 11

export const toBrazilianPhone = (phone: string) => {
  const digits = stringFormat.onlyNumbers(phone)

  if (!digits) return ''

  const hasCountryCode = digits.startsWith('55') && digits.length > NATIONAL_NUMBER_MAX_LENGTH

  return hasCountryCode ? `+${digits}` : `+55${digits}`
}
